import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
// var myIP = require('my-ip');
var browserInfo = require('browser-info');
var ip = require('ip');
const publicIp = require('public-ip');
class Page404 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      from:null,
      publicIp:null,
      ip_v4:null,
    }
  }
  componentDidMount(){ 
    var data = browserInfo()
    if(data){
      data = JSON.stringify(data)
    } 
    this.setState({
      from:data,
      ip_v4:JSON.stringify(ip.address()),
      // ip_v6:JSON.stringify(require('my-ip')("IPv6"))
    },()=>{
      (async () => {
          this.setState({publicIp:await publicIp.v4()})  
        })();
    })
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container + " fullWidth"}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={11}>
            <Card testimonial>
              <div >
                <h1>Page 404</h1>
              </div>
              <CardBody> 
                 Have not this path.   
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={11}>
            {this.state.from} <br/>
            {this.state.ip_v4} <br/>
            {this.state.publicIp} <br/>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(Page404);
